import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { SemanticModel } from '../../../../../../../api/initiative-data-integrations';

interface TabGeneralProps {
  semanticModel: SemanticModel;
  setSemanticModel: (semanticModel: SemanticModel) => void;
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
}

export const TabGeneral = (props: TabGeneralProps) => {
  const { semanticModel, setSemanticModel, setHasUnsavedChanges } = props;
  return (
    <div className='p-4 border rounded bg-white'>
      <Row>
        <Col lg={6}>
          <FormGroup>
            <Label for='modelName'>Model Name *</Label>
            <Input
              id='modelName'
              type='text'
              value={semanticModel.name}
              onChange={(e) => {
                setSemanticModel({ ...semanticModel, name: e.target.value });
                setHasUnsavedChanges(true);
              }}
              placeholder='e.g., sales_analytics_model'
            />
          </FormGroup>
        </Col>
        <Col lg={6}>
          <FormGroup>
            <Label for='modelDescription'>Description</Label>
            <Input
              id='modelDescription'
              type='text'
              value={semanticModel.description || ''}
              onChange={(e) => {
                setSemanticModel({ ...semanticModel, description: e.target.value });
                setHasUnsavedChanges(true);
              }}
              placeholder='Brief description of this semantic model'
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <FormGroup>
            <Label for='customInstructions'>Custom Instructions</Label>
            <Input
              id='customInstructions'
              type='textarea'
              rows={4}
              value={semanticModel.custom_instructions}
              onChange={(e) => {
                setSemanticModel({ ...semanticModel, custom_instructions: e.target.value });
                setHasUnsavedChanges(true);
              }}
              placeholder='Provide additional context or instructions for the AI assistant...'
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};
